import * as React from 'react';
import { NoveltiesCatalogueBlocContainer } from 'modules/shared-cms-catalogue/components';
import enhancer from './nouveautes-catalogue-enhancer';
import { NouveautesCatalogueProps } from '.';

import styles from './nouveautes-catalogue-component.module.css';

const nouveautesCatalogue: React.FC<NouveautesCatalogueProps> = React.memo(
    ({ products, ...rest }: NouveautesCatalogueProps) => {
        return (
            <React.Fragment>
                {products && products.length > 0 && (
                    <NoveltiesCatalogueBlocContainer
                        {...rest}
                        noveltiesTitleClassName={styles.title}
                        products={products}
                    />
                )}
            </React.Fragment>
        );
    },
);

export const NouveautesCatalogue = enhancer(nouveautesCatalogue);
